import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import { candidatosApi } from '../services/CandidatosApi';
import { estudiosApi } from 'services/EstudiosApi';
import { trabajosEjApi } from 'services/TrabajosEjApi';
import { areasEjeApi } from 'services/AreasEjeApi';
import { cargosApi } from 'services/CargosApi';
import { carrerasApi } from 'services/CarrerasApi';
import { clientesApi } from 'services/ClientesApi';
import { comunasApi } from 'services/ComunasApi';
import { entrevistasSicoApi } from 'services/EntrevistasSicoApi';
import { entrevistasOCApi } from 'services/EntrevistasOCApi';
import { estadosCandidatosApi } from 'services/EstadosCandidatosApi';
import { estadosCivilesApi } from 'services/EstadosCivilesApi';
import { estadosProcesosApi } from 'services/EstadosProcesosApi';
import { generosApi } from 'services/GenerosApi';
import { gobCargosApi } from 'services/GobCargosApi';
import { gobUnidadesApi } from 'services/GobUnidadesApi';
import { idiomasApi } from 'services/IdiomasApi';
import { industriasApi } from 'services/IndustriasApi';
import { institucionesApi } from 'services/InstitucionesApi';
import { nivelesIdiomasApi } from 'services/NivelesIdiomasApi';
import { paisesApi } from 'services/PaisesApi';
import { procesosApi } from 'services/ProcesosApi';
import { regionesApi } from 'services/RegionesApi';
import { tiposEstudiosApi } from 'services/TiposEstudiosApi';
import { trabajosEmApi } from 'services/TrabajosEmApi';
import { trabajosGobiernoApi } from 'services/TrabajosGobiernoApi';
import { uploadApi } from 'services/UploadApi';
import { estadosCandidatosPrApi } from 'services/EstadosCandidatosPrApi';
import { prCandidatosApi } from 'services/PrCandidatosApi';
import { personalidadesApi } from 'services/PersonalidadesApi';
import { usuariosApi } from 'services/UsuariosApi';
import { perfilesApi } from 'services/PerfilesApi';
import { consentimientosDatosPersonalesApi } from 'services/ConsentimientosDatosPersonalesApi';
import { plantillasConsentimientosApi } from 'services/PlantillasConsentimientosApi';

const middlewares = [
	areasEjeApi.middleware,
	candidatosApi.middleware,
	cargosApi.middleware,
	carrerasApi.middleware,
	clientesApi.middleware,
	comunasApi.middleware,
	entrevistasOCApi.middleware,
	entrevistasSicoApi.middleware,
	estadosCandidatosApi.middleware,
	estadosCivilesApi.middleware,
	estadosProcesosApi.middleware,
	estudiosApi.middleware,
	generosApi.middleware,
	gobCargosApi.middleware,
	gobUnidadesApi.middleware,
	idiomasApi.middleware,
	industriasApi.middleware,
	institucionesApi.middleware,
	nivelesIdiomasApi.middleware,
	paisesApi.middleware,
	procesosApi.middleware,
	regionesApi.middleware,
	tiposEstudiosApi.middleware,
	trabajosEjApi.middleware,
	trabajosEmApi.middleware,
	trabajosGobiernoApi.middleware,
	uploadApi.middleware,
	estadosCandidatosPrApi.middleware,
	prCandidatosApi.middleware,
	personalidadesApi.middleware,
	usuariosApi.middleware,
	perfilesApi.middleware,
	consentimientosDatosPersonalesApi.middleware,
	plantillasConsentimientosApi.middleware,
];

const store = configureStore({
	reducer: rootReducer(),
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.REACT_APP_NODE_ENV === 'development',
});

store.asyncReducers = {};

setupListeners(store.dispatch);

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(rootReducer(store.asyncReducers));
	return store;
};

export default store;
